import { UserRoles, UserRoleOrderItem } from '@/types/userGroups.types';

/**
 * Defines the order and grouping of user roles for display in the UI
 */
export const USER_ROLE_ORDER: UserRoleOrderItem[] = [
  {
    roleCode: [UserRoles.REPORTS_FILES],
  },
  {
    label: 'Pool Financial',
    roleCode: [UserRoles.FIXED_DAYS, UserRoles.ANNUAL_REPORTS, UserRoles.MONTHLY_REPORTS],
  },
  {
    label: 'Market Information',
    roleCode: [
      UserRoles.DAILY_REPORT,
      UserRoles.RECENT_FIXTURES,
      UserRoles.CARGO_COUNT,
      UserRoles.POWERBI_BASIC,
      UserRoles.POWERBI_PRIVILEGED,
      UserRoles.POWERBI_PRIVILEGED_KPC,
      UserRoles.BALTIC,
      UserRoles.BUNKER_PRICES,
    ],
  },
  {
    label: 'Chartering',
    roleCode: [UserRoles.FIXTURES, UserRoles.POSITION_LIST, UserRoles.CARGO_LIST],
  },
  {
    label: 'Administration',
    roleCode: [UserRoles.USERS, UserRoles.COMPANIES, UserRoles.USER_GROUPS],
  },
];
